import { render, staticRenderFns } from "./LabelmanagementModal.vue?vue&type=template&id=650da8f6&scoped=true&"
import script from "./LabelmanagementModal.vue?vue&type=script&lang=js&"
export * from "./LabelmanagementModal.vue?vue&type=script&lang=js&"
import style0 from "./LabelmanagementModal.vue?vue&type=style&index=0&id=650da8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650da8f6",
  null
  
)

export default component.exports